import script from "./collectList.vue?vue&type=script&lang=ts&setup=true"
export * from "./collectList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__